import {
  ReviewDetailLevel,
  ReviewDetailModule,
} from "@/lib/api/training-simulator/training-simulator-review";
import { cn } from "@/lib/utils";
import { Button } from "@somethings-ui/web";

const PILL_CLASSNAME = "!h-7 rounded-lg !px-3 transition-all";
const PILL_LABEL_CLASSNAME = "!text-body-3 font-normal";

export function TrainingReviewNavigation({
  modules,
  selectedModule,
  selectedLevel,
  onSelectModule,
  onSelectLevel,
}: {
  modules: ReviewDetailModule[];

  selectedModule: ReviewDetailModule;
  selectedLevel: ReviewDetailLevel;
  onSelectModule: (newModule: ReviewDetailModule) => void;
  onSelectLevel: (newLevel: ReviewDetailLevel) => void;
}) {
  return (
    <div className="mb-3 flex flex-row justify-between">
      <div className="flex flex-row gap-2">
        {modules.map((module) => {
          const isSelected = selectedModule.id === module.id;
          return (
            <Button
              key={module.id}
              onClick={() => onSelectModule(module)}
              fullWidth={false}
              variant="tertiary"
              shape="rounded"
              size="sm"
              className={cn(
                PILL_CLASSNAME,
                isSelected ? "bg-[#5FA74A]" : "bg-gray-100",
              )}
              labelClassName={cn(
                PILL_LABEL_CLASSNAME,
                isSelected ? "!text-white" : "!text-secondary",
              )}
            >
              Module {module.position}
            </Button>
          );
        })}
      </div>

      <div className="flex flex-row gap-2">
        {selectedModule.levels.map((level) => {
          const isSelected = selectedLevel.id === level.id;
          return (
            <Button
              key={level.id}
              fullWidth={false}
              onClick={() => onSelectLevel(level)}
              variant="tertiary"
              shape="rounded"
              size="sm"
              className={cn(
                PILL_CLASSNAME,
                isSelected ? "bg-black" : "bg-gray-100",
              )}
              labelClassName={cn(
                PILL_LABEL_CLASSNAME,
                isSelected ? "!text-white" : "!text-secondary",
              )}
            >
              Level {level.position}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
